import { ClassRequestModel, CommonResponse, CreateQuestionBankReqModel, LatestNewQuestionsResponse, LatestQuestionBankResponse, QnoCountReqModel, QNPIdReq, QuestionBankResponse, QuestionBankViewReq, SubjectClassReqModel } from "@boi/shared-models";
import { AxiosRequestConfig } from "axios";
import { CommonAxiosService } from "../common-axios-service";
import { assignAndGetLoaingReqStatusForHeaders as assignAndGetLoadingReqStatusForHeaders } from "../loading-helper";


export class CreateQuestionBankService extends CommonAxiosService {

    private getURLwithMainEndPoint(childUrl: string) {
        return '/createQuestionBank/' + childUrl;
    }

    async createQuestionBank(req: any[], config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('createQuestionBank'), req, config);
    }

    async bulkCreateQuestionBank(req: any, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('bulkCreateQuestionBank'), req, config);
    }

    async updateQuestionBank(req: any, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('updateQuestionBank'), req, config);
    }


    async getAllQuestionBankData(req: QuestionBankViewReq, config?: AxiosRequestConfig): Promise<QuestionBankResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllQuestionBankData'), req, config)
    }

    async GetSingleQuestionBankData(req: QuestionBankViewReq, config?: AxiosRequestConfig): Promise<LatestNewQuestionsResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('GetSingleQuestionBankData'), req, config)
    }

    async getAllLatestQuestionBankData(req: QuestionBankViewReq, config?: AxiosRequestConfig): Promise<LatestQuestionBankResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllLatestQuestionBankData'), req, config)
    }

    async activateOrDeactivateQuestion(req: QNPIdReq, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('activateOrDeactivateQuestion'), req, config)
    }

    async approveQuestion(req: any, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('approveQuestion'), req, config)
    }

    async activateOrDeactivateLatestQuestion(req: QNPIdReq, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('activateOrDeactivateLatestQuestion'), req, config)
    }

    async getQuestionsCountSummery(req: ClassRequestModel, hideLoadingSymbol?: boolean, config?: AxiosRequestConfig): Promise<CommonResponse> {
        const modifiedConfig = assignAndGetLoadingReqStatusForHeaders(hideLoadingSymbol, config);
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getQuestionsCountSummery'), req, modifiedConfig)
    }

    async getQuestionSubjectPivot(req: ClassRequestModel, hideLoadingSymbol?: boolean, config?: AxiosRequestConfig): Promise<CommonResponse> {
        const modifiedConfig = assignAndGetLoadingReqStatusForHeaders(hideLoadingSymbol, config);
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getQuestionSubjectPivot'), req, modifiedConfig)
    }

    async getAllCollegeCodesAndSymbols(config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllCollegeCodesAndSymbols'), config)
    }

    async getAllDepartments(config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllDepartments'), config)
    }

    async getAllQuestionsCountsBySubject(req: SubjectClassReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAllQuestionsCountsBySubject'), req, config)
    }

    async getLanguagesByChapter(chapterId: number, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosGetCall(this.getURLwithMainEndPoint(`getLanguagesByChapter/${chapterId}`), config);
    }

    async getRandomQuestionsForModeration(req: { noOfQuestions: number, noOfSets?: number }, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getRandomQuestionsForModeration'), req, config);
    }

    async getSiblingsByRefNo(refNo: number, refYear: string, classId: number, subjectId: number, config?: AxiosRequestConfig): Promise<CommonResponse> {
        const yearParam = refYear ? `?refYear=${encodeURIComponent(refYear)}` : '';
        return await this.axiosGetCall(this.getURLwithMainEndPoint(`getSiblingsByRefNo/${refNo}/${classId}/${subjectId}${yearParam}`), config);
    }

    async getQuestionCountsReport(req: SubjectClassReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getQuestionCountsReport'), req, config);
    }

    async getQuestionTypeDistribution(req: SubjectClassReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getQuestionTypeDistribution'), req, config);
    }

    async getQuestionAbilityDistribution(req: SubjectClassReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getQuestionAbilityDistribution'), req, config);
    }

        async getAvailableQuestionsByChapterAndSubAbility(req: QnoCountReqModel, config?: AxiosRequestConfig): Promise<CommonResponse> {
        return await this.axiosPostCall(this.getURLwithMainEndPoint('getAvailableQuestionsByChapterAndSubAbility'), req, config)
    }
}
